export default __webpack_public_path__ + "static/media/server-redundancy-illustration.c60061a0.svg";